module.exports = __webpack_public_path__ + "img/audio-cover.0dceda4e.png";